import "rc-slider/assets/index.css";
import "./slider.scss";

import classNames from "classnames";
import PropTypes from "prop-types";
import RCSlider from "rc-slider";

/**
 * Slider component wrapping rc-slider with custom handle rendering.
 *
 * @param root0 - The component props.
 * @param root0.step - The slider step increment.
 * @param root0.defaultValue - The initial slider value.
 * @param root0.onChange - The change event handler.
 * @param root0.enableDots - Whether to render step dots.
 * @returns The rendered slider component.
 */
const Slider = ({ step, defaultValue, onChange, enableDots }) => {
    const handleStopPropagation = (e) => {
        // Prevent events from bubbling up to parent dropdown menus
        e.stopPropagation();
    };

    const handleRender = (node, handleProps) => {
        return (
            <div
                {...node.props}
                className={classNames(node.props.className, "handler")}
            >
                <div className="indicator">
                    <div className="top" />
                    <div className="value">{handleProps.value}</div>
                    <div className="bottom" />
                </div>
            </div>
        );
    };

    return (
        <div
            className="slider"
            onClick={handleStopPropagation}
            onMouseDown={handleStopPropagation}
        >
            <RCSlider
                dots={enableDots}
                step={step}
                className="slider"
                handleRender={handleRender}
                defaultValue={defaultValue}
                onChange={onChange}
            />
        </div>
    );
};

Slider.propTypes = {
    step: PropTypes.number,
    defaultValue: PropTypes.number,
    onChange: PropTypes.func,
    enableDots: PropTypes.bool,
};

export default Slider;
